<div class="modal-header" (click)="common.outSide($event)">
  <h4 class="modal-title pull-left">Choix de la periode </h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
      <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" style="height: auto" (click)="common.outSide($event)">
  <div class="row">
          <div class="form-group col-sm-12">
              <label class="col-sm-4" for="debut" style="padding: 0;"> Date debut : </label>
              <app-input-date class="col-sm-8" [class]="'form-control input-simple'" [dateVide]="dateVide"
               [id]="'debut'" [model]="dateDebut" (changefct)="changeDate($event, true);"></app-input-date>
          </div>
          <div class="form-group col-sm-12">
              <label  class="col-sm-4" for="fin" style="padding: 0;"> Date fin: </label>
              <app-input-date class="col-sm-8" [class]="'form-control input-simple'"  [dateVide]="dateVide"
               [id]="'fin'" [model]="dateFin" (changefct)="changeDate($event);"></app-input-date>
          </div>
  </div>
  <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="valider()"> Valider </button>
      <button type="button" class=" btn-close" (click)="common.closeModal()"> Annuler </button>
  </div>
</div>